import { Button } from "@mui/material";
import React from "react";
import { useAppDispatch, useAppSelector } from "../../../../../../app/hooks";
import { EstimatedProcedure } from "../../../../../../services/verifyService/model/verification/EstimatedProcedure";
import { addProcedure, resetCarveOutCombo,  
} from "../../../../../../services/verifyService/model/verification/VerificationSlice";
import { CarveOutRules } from "../../../../specs/carveouts/CarveOutRules";
import { toggleOutPatientLCodeMatching } from "../../../../../../app/slices/VerificationModuleSlice";

function ApplyCarveOutCodes() {
  var dispatch = useAppDispatch();
  const verification = useAppSelector(
    (state) => state.verification.verification
  );
  const add = (proc: EstimatedProcedure) => {
    dispatch(addProcedure(proc));
  };
  const handleSave = () => {
    dispatch(toggleOutPatientLCodeMatching());
    
    // Accumulate all procedures (existing + newly added) to ensure each combo
    // sees the correct count including additions from previous combos
    let allProcedures = [...verification.procedures];
    
    verification.carveOutCombos.forEach((combo) => {
      const carveOuts = CarveOutRules.Apply(combo, allProcedures);
      carveOuts.forEach((proc) => {
        if (proc?.code && proc.description) {
          add(proc);
          // Add to local accumulator so next combo iteration sees it
          allProcedures.push(proc);
        }
      });
    });
    
    dispatch(resetCarveOutCombo());
  };
  return (
    <React.Fragment>
      <Button
        variant="outlined"
        onClick={() => {
          handleSave();
        }}
      >
        Apply
      </Button>
    </React.Fragment>
  );
}

export { ApplyCarveOutCodes };
